import { render, staticRenderFns } from "./ReservationsHome.vue?vue&type=template&id=3a6d7102"
import script from "./ReservationsHome.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservationsHome.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports